import { X, Layers, ListOrdered } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { fmtDate, presetRange, STATUS_META } from "@/lib/format";
import { Button } from "@/components/ui/button";

export const DrillBar = ({ filters, drill, defaultPreset, count, onView }) => {
  const { meta } = useAuth();
  const storeName = (c) => meta.stores.find((s) => s.code === c)?.name || c;
  const concName = (c) => (c === "none" ? "Store only" : meta.concessions.find((x) => x.code === c)?.name || c);
  const chips = [
    filters.preset === "custom" && { k: "period", label: `${fmtDate(filters.date_from)} – ${fmtDate(filters.date_to)}`, reset: { preset: defaultPreset, ...presetRange(defaultPreset) } },
    filters.region !== "all" && { k: "region", label: filters.region, reset: { region: "all", store: "all", concession: "all" } },
    filters.store !== "all" && meta.stores.length > 1 && { k: "store", label: storeName(filters.store), reset: { store: "all", concession: "all" } },
    filters.concession !== "all" && { k: "concession", label: concName(filters.concession), reset: { concession: "all" } },
    filters.category !== "all" && { k: "category", label: filters.category, reset: { category: "all" } },
    filters.sap_code !== "all" && { k: "product", label: `SAP ${filters.sap_code}`, reset: { sap_code: "all" } },
    filters.status !== "all" && { k: "status", label: STATUS_META[filters.status]?.label, reset: { status: "all" } },
  ].filter(Boolean);

  return (
    <div className="rise flex flex-wrap items-center gap-2 rounded-lg border border-slate-900 bg-[#111214] px-4 py-3 text-white" data-testid="drill-bar">
      <Layers className="h-4 w-4 text-[#FF0000]" />
      <span className="mr-1 text-xs font-semibold uppercase tracking-wider text-slate-400">{chips.length ? "Drilled into" : "Click any chart to drill in"}</span>
      {chips.map((c) => (
        <span key={c.k} className="flex items-center gap-1 rounded-full bg-white/10 py-1 pl-3 pr-1 text-xs" data-testid={`drill-chip-${c.k}`}>
          <span className="text-slate-400">{c.k}:</span> {c.label}
          <button onClick={() => drill(c.reset)} className="rounded-full p-0.5 hover:bg-white/20" data-testid={`drill-chip-remove-${c.k}`}><X className="h-3 w-3" /></button>
        </span>))}
      {chips.length > 0 && <button onClick={() => drill(null)} className="text-xs text-slate-400 underline-offset-2 hover:text-white hover:underline" data-testid="drill-clear">Clear all</button>}
      <Button size="sm" onClick={onView} className="ml-auto bg-[#FF0000] hover:bg-[#D60000]" data-testid="drill-view-orders-btn">
        <ListOrdered className="mr-1 h-4 w-4" />View {count} orders
      </Button>
    </div>
  );
};
